import {Component, OnInit} from "@angular/core";
import {DialogComponent} from '../../../../../ng2-bootstrap-modal/dialog.component';
import {DialogService} from '../../../../../ng2-bootstrap-modal/dialog.service';

@Component({
    selector: 'db-already-have-account-dialog',
    templateUrl: './already-have-account-dialog.component.html',
    styleUrls: ['./already-have-account-dialog.component.scss'],
    standalone: false
})
export class AlreadyHaveAccountDialogComponent extends DialogComponent<null, Boolean> implements OnInit {


  constructor(
    private _dialogService: DialogService
  ) {
    super(
      _dialogService
    );
  }


  ngOnInit(): void {

  }


}
